<template>
  <v-app id="app2">
    <v-container fluid class="pt-0 mt-0">
        <v-row
        
          class="lighten-5 pa-0 ma-0"
          style="height: 100%;"
        >

        <v-col cols="4" class="mt-0" >
            <FbSession />
      
        </v-col>
        <v-divider
          class="mx-4"
          style="height:100vh;"
          vertical
        ></v-divider>
      <v-col cols="4">
          <IGSession />
         <!-- <v-chip-group column>
            <v-chip style="white-space:normal;" v-for="item in items" :key="item.name" v-bind:class="{ height_auto: (item.message.length>43),'py-2': (item.message.length>43) }">
                  <v-avatar left>
                      <v-icon color="#c08d64">fab fa-instagram</v-icon>
                 </v-avatar>
                  
                 sadsadfasdfas
                 <v-subheader>Subheader</v-subheader>
          </v-chip>
         </v-chip-group> -->
        </v-col>
   <v-divider
          class="mx-4"
          style="height:100vh;"
          vertical
        ></v-divider>
      <v-col cols="3">
          <v-chip-group column>
            <v-chip style="white-space:normal;" v-for="item in items" :key="item.name" v-bind:class="{ height_auto: (item.message.length>43),'py-2': (item.message.length>43) }">
             
                  <v-avatar left>
                      <v-icon color="#FF0000">fab fa-youtube</v-icon>
                    <!-- <v-img :src="require('./assets/logo.png')"></v-img> -->
                  </v-avatar>
                  
                 sadsadfasdfas
                 <v-subheader>Subheader</v-subheader>
          </v-chip>
          
          
          </v-chip-group>
        </v-col> 



      </v-row>
      
    </v-container>
  </v-app>
</template>
<style>
.height_auto{
    height: auto !important;
    /* padding: 2px 0 !important; */
}
</style>
<script>
import FbSession from './FbSession'
import IGSession from './IGSession'
  export default {
    name: "CCComment",
    data(){
      return {
        alignment: 'start',
        // dense: false,
        items: [
          {name:"ccsy2", message:"text msgtext msgtext adadadsadadasdasdsadsd"},
          {name:"ccsy3", message:"text msg"}
        ],
        items2: [
        //   {name:"ccsy2", message:"text msgtext msgtext adadadsadadasdasdsadsd"},
        //   {name:"ccsy3", message:"text msg"}
        ],
        justify: 'space-between',
      };
    },
    components:{
        FbSession,
        IGSession
    },
    mounted(){
       
    }
    
  }
</script>

      